import { ELanguagePreference } from "@frontend-shared/types";
import type { Locale } from "date-fns";
import { ar, enUS, ru } from "date-fns/locale";

// NOTE: date-fns formats in English unless a locale is passed, which would put
// an English phrase inside an already-translated sentence (and LTR text on an
// Arabic RTL line). i18next reports tags like "ru-RU", so match the base subtag.
export const resolveDateFnsLocale = (language: string): Locale => {
  const [baseTag] = language.toLowerCase().split("-");

  switch (baseTag) {
    case ELanguagePreference.AR:
      return ar;
    case ELanguagePreference.RU:
      return ru;
    default:
      return enUS;
  }
};
